var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getLeilao && _vm.getLeilao.linkYoutube)?_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('div',{staticClass:"youtube",domProps:{"innerHTML":_vm._s(_vm.getLeilao.linkYoutube)}})])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }